import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject, catchError, map, of, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DeploymentService } from './deployment.service';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  private cancelPrevReq = new Subject();

  constructor(private http: HttpClient, private snackBar: MatSnackBar, private depService: DeploymentService, private env: EnvironmentService) { }

  checkIfUtilityServiceActive(ip: string, depName: string): Observable<boolean> {
    this.cancelPrevReq.next(null);
    if(this.depService.isRouteViaSynchpcEnabled(depName)) return of(true);

    const url = `${this.env.envVariables.httpProtocol}${ip}:${this.env.envVariables.UtilityAccessPort}/authorize`;
  
    return this.http.get(url, { responseType: 'text' }).pipe(
      takeUntil(this.cancelPrevReq),
      map(response => true),
      catchError(error => {
        this.openSnackBar(url, depName);
        return of(false);
      })
    );
  }

  openSnackBar(url: string, depName: string) {
    if(!this.depService.isCheckUtilityServiceEnabled(depName)) return of(true);
    this.snackBar.open("Utility Service is not active", "Activate")
    .afterDismissed().subscribe(data => {
      const newTab = window.open(url, "_blank");
    });
  }
}
